import React, { Component } from 'react';
import { connect } from "react-redux";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { Grid, Divider } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Table, TableCell, TableHead, TableBody, TableRow, Paper, Fab, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import moment from "moment";
import {isMobile} from "../../../../api/index";
import CustomTableHead from "../../../generales/CustomTableHead";
import {ID_FORMATO_DIGITAL} from "../../../../api/config";


class ListaTrabajos extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  

  async crearTrabajo() {
    this.props.history.push(`/crear-trabajo/${this.props.match.params.id}`);
  }


  getCleanedString(cadena) {
    if (cadena == null)
        return '';
    
    cadena = cadena.toLowerCase();    
    return cadena;
}

estado = (nombre) => {
    let nombreLimpio = this.getCleanedString(nombre);
    if (nombreLimpio !== '')
        return (
            <div >
                { <img alt={200} src={this.iconUrl(nombreLimpio)} /> }
                {nombre}
            </div>);
}

iconUrl = (nombreLimpio) => {
    try {
        return require(`../../../Tramitaciones/IconosEstados/${nombreLimpio}.svg`);
    } catch (e) {
        //let nombreLimpio='borrador'
        //return require(`../../../Tramitaciones/IconosEstados/${nombreLimpio}.svg`);
    }
}

onClickTrabajo(Id_Expediente ,Id_Trabajo) {

  this.props.history.push("/visualizar-expediente/" + Id_Expediente + "/" + Id_Trabajo);
}

  render() {
    let { classes } = this.props;
    return (
      <Paper className={!isMobile() ?`without-radius m-3` : `without-radius m-1`}>    
        <Grid container >
          <Grid item xs={10} md={10}>
            <Typography variant="display4" gutterBottom className="m-3">
              <Translate id="languages.fichaExpediente.titleListaTrabajos" />
            </Typography>
              
          </Grid>
          
          <Grid item xs={2}  md={2} >
            {
              this.props.expediente.Expediente[0].SePuede_CrearTrabajo==1 &&
              <Fab size="small" color="primary" aria-label="Add"   className={"fab-listatrabajos"}
              onClick={() => { this.crearTrabajo() }}>
              <Add />
              </Fab>
            }
          </Grid>

          <Grid item md={12}>
            <Divider style={{ height: 3 }} />
          </Grid>
        </Grid>
        <div className={"table-wrapper"}>
          <Table >
            <TableHead>
              <TableRow className={"head-height"} >
                <CustomTableHead className="text-uppercase px-3">N.</CustomTableHead>
                <CustomTableHead className="text-uppercase">
                  <Translate id="languages.trabajo.tableColumnTitle" />
                </CustomTableHead>
                <CustomTableHead className="pl-3 text-uppercase">
                  <Translate id="languages.trabajo.tableColumnState" />
                </CustomTableHead>
                <CustomTableHead className="text-uppercase px-2">
                  <Translate id="languages.generalButton.date" />
                </CustomTableHead>
                <CustomTableHead className="text-uppercase px-2">
                  <Translate id="languages.trabajo.tableColumnVisado" />
                </CustomTableHead>

            
              </TableRow>
            </TableHead>

            <TableBody className={"table-body-height"}>
              {
                this.props.expediente.Trabajos.length === 0 ?
                  <TableRow>
                    <TableCell colSpan={6}></TableCell>
                  </TableRow>
                  : this.props.expediente.Trabajos.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row" className="px-1 text-center">
                          {row.Id_Trabajo}
                        </TableCell>
                        <TableCell className="p-1">
                          <a className={"link"  } style={{color:row.Incidencias && row.SePuede_Editar > 0 ?'#dc3545':'#007bff'}} onClick={() => this.onClickTrabajo(row.Id_Expediente,row.Id_Trabajo)}>
                            {row.Titulo}
                          </a>
                        </TableCell>
                        <TableCell className="p-2"> 
                          {row.Tiene_Estado ?
                                <div className='estados'>
                                        {this.estado(row.Estado ? row.Estado.replace("Pendente","Pen.").replace("Pendiente","Pen.") : "" )}
                                 </div>
                             :<div style={{ marginLeft: '20px' }}>-</div>
                          }      
                         </TableCell>
                        <TableCell className="p-0 text-center">{row.Fecha_Entrada ? moment(row.Fecha_Entrada).format("DD/MM/YY") : "-"}</TableCell>
                        <TableCell className="p-0 text-center">{row.Fecha_Tramitacion ? moment(row.Fecha_Tramitacion).format("DD/MM/YY") : "-"}</TableCell>                       
                      </TableRow>
                    );
                  })
              }
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
};

ListaTrabajos.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(ListaTrabajos)));